import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { ViewPrivilegesWrapper } from "../../Components/ManageUsers/ManageUsers/ManageUsersStyled";
import { Box, Typography } from "@mui/material";
import { Constants, BundleNotesHeader } from "./Content";
import SearchInput from "../utilities/SearchInput/SearchInput";
import BundleNotesTable from "../utilities/NoteTable/BundleNoteTable";
const ViewBundleNotesDialog = ({ title, show, handleClose, notes }) => {
    const [noteRow, setNoteRow] = useState(notes);
    const [noteRows, setNoteRows] = useState(notes);
    
    const handleChangeSearch = (text) => {
        setNoteRows(null);
        const tablesrows =
            text === ""
                ? [...noteRow]
                : noteRow.filter((item) =>
                    Object.values(item).some(
                        (value) =>
                            typeof value === "string" &&
                            value.toLowerCase().includes(text.toLowerCase())
                    )
                );
        console.log(tablesrows, "tablerows");
        setNoteRows([...tablesrows]);
    };
    return (
        <ViewPrivilegesWrapper
            open={show}
            onClose={handleClose}
            scroll="paper"
            maxWidth="xs"
            fullWidth={true}
            
        >
            <DialogTitle id="alert-dialog-title" className="customDialogTitle">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    id="alert-dialog-description"
                    className="customDialog"
                >
                    <Box className="noteTable">
                        <div className="searchInput">
                            <h5>{Constants.SEARCH} </h5>
                            <SearchInput
                                placeholder="Search by whom and message"
                                onSearchChange={handleChangeSearch}
                            />
                        </div>
                        {noteRows && <BundleNotesTable headers={BundleNotesHeader} rows={noteRows} noDataMessage={noteRows?.length === 0} />}
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions className="dialogbutton">
                <Button variant="contained" color="success" onClick={handleClose}>
                    {Constants.OK}
                </Button>
            </DialogActions>
        </ViewPrivilegesWrapper>
    );
};

export default ViewBundleNotesDialog;
